export enum TicketLayoutType
{
    LAYOUT60MM = 1,
    LAYOUT80MM = 2
}